import { combineReducers } from "redux";
import { OtherReducer, OtherState } from "./other";
import { UserReducer, UserState } from "./user";
import { CheckoutReducer, CheckoutState } from "./checkout";
import { TransactionReducer, TransactionState } from "./transaction";

export const rootReducer = combineReducers({
  user: UserReducer,
  other: OtherReducer,
  checkout: CheckoutReducer,
  transaction: TransactionReducer,
});

export interface RootState {
  user: UserState;
  other: OtherState;
  checkout: CheckoutState;
  transaction: TransactionState;
}
